import useCategoryFeedbackFormHandling from '../ViewApplicantAnswersWizard/useCategoryFeedbackFormHandling';
import { DietaryHabitsAndHealthUIConfig } from '../../../shared/CategoryStepUIConfig';
import { useViewCareTeamApplicantAnswers } from './useViewCareTeamApplicantAnswers';
import { CategoryViewApplicantAnswersStep } from '../ViewApplicantAnswersWizard/CategoryViewApplicantAnswersStep';

const UiConfig = DietaryHabitsAndHealthUIConfig;

export const DietaryHabitsAndHealthCareTeamStep = () => {
	const { application } = useViewCareTeamApplicantAnswers();

	const { form } = useCategoryFeedbackFormHandling();

	return (
		<CategoryViewApplicantAnswersStep
			uiConfig={UiConfig}
			form={form}
			answers={application?.userAnswers}
			checkForCareTeamQuestions
		/>
	);
};
